import { PERMISSIONS } from './constants';
import { IPermissionsData } from './types';

// Resolves a dotted-path lookup (e.g. 'bulk_upload.index') against a permissions object.
export function lookupPermission(permissions: IPermissionsData | null, path: string): boolean | undefined {
  if (!permissions || !path) return undefined;

  const value = path
    .split('.')
    .reduce<unknown>(
      (acc, key) => (acc == null || typeof acc !== 'object' ? undefined : (acc as Record<string, unknown>)[key]),
      permissions,
    );

  return typeof value === 'boolean' ? value : undefined;
}

// The permission alone decides pricing access — do not add a hostname or environment bypass.
export function hasPricingAccess(permissions: IPermissionsData | null, path: string): boolean {
  return lookupPermission(permissions, path) === true;
}

// A route or menu item is gated either by one dotted key or by a check that reads several.
export type PermissionCheck = string | ((permissions: IPermissionsData | null) => boolean);

export function isPermissionGranted(permissions: IPermissionsData | null, check: PermissionCheck): boolean {
  return (typeof check === 'function' ? check(permissions) : lookupPermission(permissions, check)) === true;
}

// The Rate Engine pages have their own read key; when the server does not send it, the Pricing section key decides.
export function canReadEngines(permissions: IPermissionsData | null): boolean {
  const engineRead = lookupPermission(permissions, PERMISSIONS.pricing_settings.engines.index);

  return engineRead === undefined ? hasPricingAccess(permissions, PERMISSIONS.pricing_settings.index) : engineRead;
}
